import React, {useEffect, useRef} from 'react';
import Particles from "react-particles-js";
import classes from "./App.module.scss";
import Splash from "./pages/Splash/Spash";
import {particleConfig} from "./const";
import About from "./pages/About/About";
import Projects from "./pages/Projects/Projects";
import Skills from "./pages/Skills/Skills";
import Contact from "./pages/Contact/Contact";
import Gallery from "./pages/Gallery/Gallery";
import Services from "./pages/Services/Services";
import Questions from "./pages/Questions/Questions";
import ReactPixel from 'react-facebook-pixel'
import ReactGA from "react-ga";

function App() {
	const containerRef = useRef<HTMLDivElement | null>(null)

	useEffect(() => {
		ReactPixel.pageView();
		ReactGA.pageview('/')
	}, [])

	return (
		<div className={classes.container}>
			<div className={classes.foreground} ref={containerRef}>
				<Splash containerRef={containerRef}/>
				<About/>
				<Projects/>
				<Gallery/>
				<Skills/>
				<Services/>
				<Questions/>
				<Contact/>
			</div>
			<div className={classes.background}>
				<Particles
					params={particleConfig}
					height='100vh'
					width='100vw'
				/>
			</div>
		</div>
	);
}

export default App;
